import React, { useState } from 'react';
import LoadScript from "react-load-script";
import { formatPhoneNumber } from "../../util/helper";
import { googleIdMobilePay, merchantId } from '../../util/apiUtil';
import generateOrderId from '../forms/CreditCardEprotect/generateOrderId';
var orderId = generateOrderId();
/**
 * Define the version of the Google Pay API referenced when creating your
 * configuration
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|apiVersion in PaymentDataRequest}
 */

var baseRequest = {
  apiVersion: 2,
  apiVersionMinor: 0,
  shippingAddressRequired: false,
  emailRequired: true
};
/**
 * Card networks supported by your site and your gateway
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
 * @todo confirm card networks supported by your site and gateway
 */

var allowedCardNetworks = ["AMEX", "DISCOVER", "MASTERCARD", "VISA"];
/**     
 * Card authentication methods supported by your site and your gateway
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
 * @todo confirm your processor supports Android device tokens for your
 * supported card networks
 */

var allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];
/**
 * Describe your site's support for the CARD payment method and its required
 * fields
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
 */

var baseCardPaymentMethod = {
  type: 'CARD',
  parameters: {
    allowedAuthMethods: allowedCardAuthMethods,
    allowedCardNetworks: allowedCardNetworks,
    billingAddressRequired: true,
    billingAddressParameters: {
      format: "FULL",
      phoneNumberRequired: false
    }
  }
};
/**
 * An initialized google.payments.api.PaymentsClient object or null if not yet set
 *
 * @see {@link getGooglePaymentsClient}
 */

var paymentsClient = null;
/**
 * Configure your site's support for payment methods supported by the Google Pay
 * API.
 *
 * Each member of allowedPaymentMethods should contain only the required fields,
 * allowing reuse of this base request when determining a viewer's ability
 * to pay and later requesting a supported payment method
 *
 * @returns {object} Google Pay API version, payment methods supported by the site
 */

function getGoogleIsReadyToPayRequest() {
  return Object.assign({}, baseRequest, {
    allowedPaymentMethods: [baseCardPaymentMethod]
  });
}
/**
 * Configure support for the Google Pay API
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|PaymentDataRequest}
 * @returns {object} PaymentDataRequest fields
 */


function getGooglePaymentDataRequest(props) {
  var paymentDataRequest = Object.assign({}, baseRequest);
  var check = props.check;
  /**
   * Identify your gateway and your site's gateway merchant identifier
   *
   * The Google Pay API response will return an encrypted payment method capable
   * of being charged by a supported gateway after payer authorization
   *
   * @todo check with your gateway on the parameters to pass
   * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#gateway|PaymentMethodTokenizationSpecification}
   */

  var tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
      'gateway': 'vantiv',
      'gatewayMerchantId': "".concat(merchantId),
      'vantiv:merchantPayPageId': "".concat(googleIdMobilePay.payPageId),
      // 'vantiv:merchantOrderId':   `0`,
      'vantiv:merchantOrderId': "".concat(check.Store, "-").concat(check.OrderCode),
      //orderId,,
      'vantiv:merchantTransactionId': "".concat(check.Store, "-").concat(check.OrderCode),
      'vantiv:merchantReportGroup': "".concat(googleIdMobilePay.merchantReportGroup)
    }
  };
  /**
   * Describe your site's support for the CARD payment method including optional
   * fields
   *
   * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
   */

  var cardPaymentMethod = Object.assign({}, baseCardPaymentMethod, {
    tokenizationSpecification: tokenizationSpecification
  });
  paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
  paymentDataRequest.transactionInfo = getGoogleTransactionInfo(props); // paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"];
  // paymentDataRequest.paymentDataCallbacks =  {
  //   onPaymentDataChanged: onPaymentDataChanged
  // }

  paymentDataRequest.merchantInfo = {
    merchantId: "".concat(googleIdMobilePay.merchantId),
    merchantName: 'Cracker Barrel'
  };
  return paymentDataRequest;
}
/**
 * Return an active PaymentsClient or initialize
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/client#PaymentsClient|PaymentsClient constructor}
 * @returns {google.payments.api.PaymentsClient} Google Pay API client
 */


function getGooglePaymentsClient() {
  // const environment =(env === 'production') ? 'PRODUCTION' : 'TEST'
  // MOBILE PAY PRODUCTION IN STAGE
  if (paymentsClient === null) {
    paymentsClient = new google.payments.api.PaymentsClient({
      environment: "".concat(googleIdMobilePay.environment)
    });
  }

  return paymentsClient;
}
/**
 * Initialize Google PaymentsClient after Google-hosted JavaScript has loaded
 *
 * Display a Google Pay payment button after confirmation of the viewer's
 * ability to pay.
 */


function onGooglePayLoaded(props) {
  var paymentsClient = getGooglePaymentsClient();

  if (paymentsClient) {
    props.setGoogleLoaded(true);
    paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest()).then(function (response) {
      if (response.result) {
        addGooglePayButton(props); // @todo prefetch payment data to improve performance after confirming site functionality
        // prefetchGooglePaymentData();
      }
    }).catch(function (err) {
      // show error in developer console for debugging
      console.error(err);
    });
  }
}
/**
 * Add a Google Pay purchase button alongside an existing checkout button
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#ButtonOptions|Button options}
 * @see {@link https://developers.google.com/pay/api/web/guides/brand-guidelines|Google Pay brand guidelines}
 */


function addGooglePayButton(props) {
  var paymentsClient = getGooglePaymentsClient();
  var button = paymentsClient.createButton({
    buttonSizeMode: 'fill',
    onClick: function onClick() {
      onGooglePaymentButtonClicked(props);
    }
  });
  document.getElementById('googlepayButton').appendChild(button);
}
/**
 * Provide Google Pay API with a payment amount, currency, and amount status
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#TransactionInfo|TransactionInfo}
 * @returns {object} transaction info, suitable for use as transactionInfo property of PaymentDataRequest
 */


function getGoogleTransactionInfo(props) {
  return {
    countryCode: 'US',
    currencyCode: 'USD',
    totalPriceStatus: 'FINAL',
    // set to cart total
    totalPrice: "".concat(props.cost.Total)
  };
}
/**
 * Prefetch payment data to improve performance
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/client#prefetchPaymentData|prefetchPaymentData()}
 */
// function prefetchGooglePaymentData() {
//   const paymentDataRequest = getGooglePaymentDataRequest();
//   // transactionInfo must be set but does not affect cache
//   paymentDataRequest.transactionInfo = {
//     totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
//     currencyCode: 'USD'
//   };
//   const paymentsClient = getGooglePaymentsClient();
//   paymentsClient.prefetchPaymentData(paymentDataRequest);
// }

/**
 * Show Google Pay payment sheet when Google Pay payment button is clicked
 */


function onGooglePaymentButtonClicked(props) {
  var paymentDataRequest = getGooglePaymentDataRequest(props);
  paymentDataRequest.transactionInfo = getGoogleTransactionInfo(props);
  var paymentsClient = getGooglePaymentsClient();
  paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
    // handle the response
    processPayment(paymentData, props);
  }).catch(function (err) {
    // show error in developer console for debugging
    console.error(err);
  });
}
/**
 * Process payment data returned by the Google Pay API
 *
 * @param {object} paymentData response from Google Pay API after user approves payment
 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentData|PaymentData object reference}
 */


function processPayment(paymentData, props) {
  // show returned data in developer console for debugging
  // @todo pass payment token to your gateway to process payment
  handlePaymentResponse(paymentData, props);
}

function onPaymentAuthorized(paymentData) {
  return new Promise(function (resolve, reject) {
    // handle the response
    console.log('onPaymentAuthorized', paymentData);
    processPayment(paymentData).then(function () {
      resolve({
        transactionState: 'SUCCESS'
      });
    }).catch(function () {
      resolve({
        transactionState: 'ERROR',
        error: {
          intent: 'PAYMENT_AUTHORIZATION',
          message: 'Insufficient funds, try again. Next attempt should work.',
          reason: 'PAYMENT_DATA_INVALID'
        }
      });
    });
  });
}

var cleanPhone = function cleanPhone(phone) {
  return formatPhoneNumber(phone.replace(/^\+[0-9]/, ''));
};

var handlePaymentResponse = function handlePaymentResponse(response, props) {
  var _response$paymentMeth, _response$paymentMeth2, _response$paymentMeth3, _response$paymentMeth4, _response$paymentMeth5;

  var payForOrder = props.payForOrder,
      check = props.check,
      gratuity = props.gratuity;
  var fullname = (_response$paymentMeth = response.paymentMethodData.info) === null || _response$paymentMeth === void 0 ? void 0 : _response$paymentMeth.billingAddress.name;
  var name = fullname === null || fullname === void 0 ? void 0 : fullname.split(' ');
  var billingAddress = (_response$paymentMeth2 = response.paymentMethodData.info) === null || _response$paymentMeth2 === void 0 ? void 0 : _response$paymentMeth2.billingAddress;
  var card = (_response$paymentMeth3 = response.paymentMethodData) === null || _response$paymentMeth3 === void 0 ? void 0 : _response$paymentMeth3.info;
  var googleInfo = {
    firstName: name[0],
    lastName: name[1],
    email: response.email,
    billingStreetAddress: billingAddress.address1,
    billingCity: billingAddress.locality,
    billingState: billingAddress.administrativeArea,
    billingZip: billingAddress.postalCode,
    paymentMethod: "google",
    lastFour: card === null || card === void 0 ? void 0 : card.cardDetails,
    cardNumber: "************".concat(card === null || card === void 0 ? void 0 : card.cardDetails),
    cardtype: card === null || card === void 0 ? void 0 : card.cardNetwork,
    wptokenizedpan: (_response$paymentMeth4 = response.paymentMethodData) === null || _response$paymentMeth4 === void 0 ? void 0 : (_response$paymentMeth5 = _response$paymentMeth4.tokenizationData) === null || _response$paymentMeth5 === void 0 ? void 0 : _response$paymentMeth5.token,
    WPOrderId: orderId,
    entrymode: "E-COMM"
  };
  var payload = {
    Store: parseInt(check.Store.replace('CB', '')),
    // check.Store,
    OrderCode: check.OrderCode,
    OrderTotal: check.TotalToPay,
    Gratuity: gratuity,
    Payments: [{
      TokenType: 'LVT',
      PaymentAmount: check.TotalToPay,
      AuthorizationToken: googleInfo.wptokenizedpan,
      // CardBin: appleInfo.bin,
      CardType: googleInfo.cardtype,
      // ExpiryDate: appleInfo.expDate,
      CardHolderName: fullname,
      CardSuffix: googleInfo.lastFour,
      IsGooglePay: true,
      OrderSource: 'androidpay'
    }],
    CustomerEmail: googleInfo.email
  };
  payForOrder(payload);
};

var googlePayEnabled = function googlePayEnabled() {
  var isReadyToPayRequest = getGoogleIsReadyToPayRequest();
  var googlePayment = paymentsClient;

  if (!googlePayment || paymentsClient === null) {
    googlePayment = getGooglePaymentsClient();
  }

  if (googlePayment) {
    return paymentsClient.isReadyToPay(isReadyToPayRequest);
  }

  return false;
};

var GooglePay = function GooglePay(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadScript, {
    url: "https://pay.google.com/gp/p/js/pay.js",
    onLoad: function onLoad() {
      onGooglePayLoaded(props);
    }
  }), /*#__PURE__*/React.createElement("div", {
    id: "googlepayButton"
  }));
};

export { GooglePay, googlePayEnabled };